module.exports = __webpack_public_path__ + "img/malawi.eab27e07.svg";